<div>
  <ng-container *ngIf="isReadMode; else writeMode">
    <span>{{ selectedLabels }}</span>
  </ng-container>

  <ng-template #writeMode>
    <div class="write-mode-container" [class.single-row]="singleRow" [style.--si-columns]="safeColumnsPerRow">
      <mat-checkbox
        *ngFor="let option of options; trackBy: trackByValue"
        color="primary"
        class="example-margin"
        [checked]="isChecked(option)"
        [disabled]="effectiveDisabled"
        (change)="onOptionChange($event, option)">
        {{ option | translate }}
      </mat-checkbox>
    </div>
  </ng-template>
</div>
